export const googleUrl = "https://sheets.googleapis.com/v4/spreadsheets/";
export const sheetId = "1sjPSmOYbhjDBFxcvXVw1ufKfowEBu1AKh8sB6T8e24Y";
export const sheetPage = "Visualisation";
